import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { PatientModel } from '../models/PatientsModel';
import { URLsConfig } from '../URLsConfig';
import { PatientInsuranceModel } from '../models/PatientInsuranceModel';
@Injectable()
export class PatientInsuranceService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getPatientInsurance(patientCode: string) {
        let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        const options = {
            params: params
        };
        return this.http.get<PatientInsuranceModel>(this.urlsconfig.WebAPIURL_Test + 'api/PatientInsurance/GetPatientInsurance', options);
    }

  public AddPatientInsurance(PatientInsurance: PatientInsuranceModel) {
      return this.http.post<PatientInsuranceModel>(this.urlsconfig.WebAPIURL_Test + 'api/PatientInsurance/AddPatientInsurance', PatientInsurance);
  }
  public delPPatientInsurance(patientCode: string ) {

    let params = new HttpParams();
      params = params.append("patientCode", patientCode);

      const options = {
        params: params
    };
    return this.http.get<PatientInsuranceModel>(this.urlsconfig.WebAPIURL_Test + 'api/PatientInsurance/DeletePatientInsurance',options);
  }

}